import { z } from 'zod'

import { ChannelType } from 'common/core/constants/ChannelType'
import { LightFlowSchema } from 'shared/api/common/schemas/flow/lightFlow'

const systemKeywordsFlowRequestSchema = z.object({ channel: z.enum(ChannelType) })

const systemFlowsResponseSchema = z.object({
  subscribe_flow: LightFlowSchema.nullable(),
  unsubscribe_flow: LightFlowSchema.nullable(),
})

const subscribeFlowResponseSchema = z.object({ flow: LightFlowSchema })

export const systemKeywordsSchemas = {
  getSystemFlows: {
    request: systemKeywordsFlowRequestSchema,
    response: systemFlowsResponseSchema,
    query: z.undefined(),
    path: z.undefined(),
  },
  getSubscribeFlow: {
    request: systemKeywordsFlowRequestSchema,
    response: subscribeFlowResponseSchema,
    query: z.undefined(),
    path: z.undefined(),
  },
  getUnsubscribeFlow: {
    request: systemKeywordsFlowRequestSchema,
    response: subscribeFlowResponseSchema,
    query: z.undefined(),
    path: z.undefined(),
  },
}
